import React, {useEffect, useState} from 'react';

import styles from './PickupPointModal.module.css'
import {DesktopModal} from "../../../../ui/Modal/desktop/DesktopModal.tsx";
import {MobileModal} from "../../../../ui/Modal/mobile/MobileModal.tsx";
import {Button} from "../../../../ui/General/Button/Button.tsx";
import {PickupPointList} from "./components/PickupPointList/PickupPointList.tsx";
import {useScreenDetector} from "../../../../hooks/useScreenDetector.ts";
import {cn} from "../../../../utils/cn.ts";
import {PickupPoint} from "./components/PickupPointList/PickupPointItem/types/PickupPoint.interface.ts";
import {Map, Placemark, YMaps} from '@pbe/react-yandex-maps';
import {Input} from "../../../../ui/DataEntry/Input/Input.tsx";
import {Icon} from "../../../../ui/General/Icon/Icon.tsx";
// import {useLocalStorage} from "../../../../hooks/useLocalStorage.ts";
import {changeCurrentBranch} from "../../../../utils/changeLocation.ts";
// import { useMultiStorage } from '../../../../hooks/useStorage.ts';
import { API_URL } from '../../../../config.tsx';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { setSelectedPickPoint, setUserInfoField } from '@/utils/storage/slices/userSlice.ts';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';
import { userInfoLoader } from '@/utils/storage/extra/loaders/user/userInfoLoader.ts';

interface Props {
    isOpen: boolean,
    forCart: boolean,
    close: () => void,
    open: () => void,
    currentBranchAddress: string,
    currentBranchId: number,
    currentTownId: number|null,
}

export const PickupPointModal: React.FC<Props> = ({
                                                      isOpen,
                                                      close,
                                                      currentBranchAddress,
                                                      currentBranchId,
                                                      currentTownId,
                                                      forCart,
}) => {
    const {isDesktop} = useScreenDetector()
    const dispatch = useAppDispatch();
    // const  {getStorageValue, setStorageValue} = useLocalStorage();
    const [isListDisplayed, setIsListDisplayed] = useState<boolean>(true);
    const [branches, setBranches] = useState<PickupPoint[]>([]);
    const [centerMapCoordinates, setCenterMapCoordinates] = useState<[number, number]>([43.136782, 131.930598]);
    const [searchAddress, setSearchAddress] = useState('');
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId);
    // const [storage, setStorage] = useMultiStorage({
    //     branchId: ['branchId', getStorageValue('branchId')],
    //     getUserData: ['getUserData', false],
    //     getCartOffer: ['getCartOffer', false],
    // });

    const getBranches = () => {
        fetch(`${API_URL}/branches_list?townId=${forCart ? currentTownId : ''}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                data.map((branch: {id: number, latitude: number, longitude: number}) => {
                    if(branch.id === currentBranchId) setCenterMapCoordinates([branch.latitude, branch.longitude]);
                })
                setBranches(data);
            })
    }

    const changeBranch = (point: PickupPoint) => {
        dispatch(setSelectedPickPoint(point.id));
        // setStorageValue('selectedPickPoint', point.id);
        changeCurrentBranch(point.id);
        setTimeout(function () {
            dispatch(setUserInfoField({name: 'branchId', value: point.id}));
            dispatch(userInfoLoader());
            dispatch(cartOfferLoader({cartId: cartId || 0, isMini: false, all: true}));
            // setStorage('branchId', point.id);
            // setStorage('getUserData', true);
            // setStorage('getCartOffer', true);
            close();
        }, 1000);
    }

    // const changeBranchMobile = (point: PickupPoint) => {
    //     dispatch(setSelectedPickPoint(point.id));
    //     // setStorageValue('selectedPickPoint', point.id);
    //     setTimeout(function () {
    //         dispatch(setUserInfoField({name: 'branchId', value: point.id}));
    //         dispatch(userInfoLoader());
    //         dispatch(cartOfferLoader({cartId: cartId || 0, isMini: false, all: true}));
    //         // setStorage('branchId', point.id);
    //         // setStorage('getUserData', true);
    //         // setStorage('getCartOffer', true);
    //         close();
    //     }, 1000);
    // }

    const changeCheckedPickPoint = (point: PickupPoint) => {
        dispatch(setSelectedPickPoint(point.id));
        // setStorageValue('selectedPickPoint', point.id);
        branches.map((branch: PickupPoint) => {
            if(branch.id === point.id && branch.latitude && branch.longitude) setCenterMapCoordinates([branch.latitude, branch.longitude]);
        })
    }

    const filterBranches = (branches: PickupPoint[]) => {
        return branches.filter(({address}) => {
                if(!searchAddress) return true;
                return address.toLowerCase().includes(searchAddress.toLowerCase());
            }
        )
    }

    useEffect(() => {
        getBranches();
    }, [currentBranchId]);

    return (
        isDesktop
        ?
            <DesktopModal isOpen={isOpen} close={close} title='Выберите ближайший пункт выдачи'>
                <div className={styles.citySettings}>
                    Ваш ПВ: &nbsp;
                    <span className={styles.currentCity}>{currentBranchAddress}</span>
                </div>

                <div className={styles.search}>
                    <Input
                        className={styles.input}
                        placeholder='Искать пункт выдачи'
                        icon={<Icon name='search' width={18} height={18} color='#F59B28'/>}
                        value={searchAddress}
                        hasBorder
                        changeStateValue={setSearchAddress}
                    />
                </div>
                <div className={styles.points}>
                    <PickupPointList
                        currentTownId={currentTownId}
                        choosePickPoint={(point) => changeBranch(point)}
                        changeCheckedPickPoint={changeCheckedPickPoint}
                        pickupPoints={filterBranches(branches)}
                    />
                    {branches.length ?
                        (<YMaps>
                            <Map
                                defaultState={{
                                    zoom: 14,
                                    controls: [],
                                    center: centerMapCoordinates,
                                }}
                                state={{
                                    zoom: 14,
                                    controls: [],
                                    center: centerMapCoordinates,
                                }}
                                width="100%"
                                height={485}
                            >
                                {filterBranches(branches).map(branch => {
                                    if(!branch.latitude || !branch.longitude || (branch.townId !== currentTownId && !(currentTownId !== 1 && branch.id === 1))) return null;

                                    return  <Placemark
                                        modules={["geoObject.addon.balloon"]}
                                        key={branch.id}
                                        defaultGeometry={[branch.latitude, branch.longitude]}
                                        // onClick={() => changeBranchMobile(branch)}
                                        onClick={() => changeBranch(branch)}
                                     />
                                })}
                            </Map>
                        </YMaps>) : null}
                </div>
            </DesktopModal>
            :
            <MobileModal
                isOpen={isOpen} close={close}
                title='Выберите ближайший пункт выдачи'
            >
                <div className={styles.wrapper}>
                    <Input
                        icon={<Icon name='search' width={18} height={18} color='#9a9a9a'/>}
                        className={styles.input}
                        placeholder='Искать пункт выдачи'
                        value={searchAddress}
                        hasBorder
                        changeStateValue={setSearchAddress}
                    />
                    <div className={styles.tabs}>
                        <Button
                            className={cn(styles.tabBtn, !isListDisplayed && styles.tabBtnNotChosen)}
                            type='regular'
                            onClick={() => setIsListDisplayed(true)}
                        >
                            Списком
                        </Button>
                        <Button
                            className={cn(styles.tabBtn, isListDisplayed && styles.tabBtnNotChosen)}
                            type='regular'
                            onClick={() => setIsListDisplayed(false)}
                        >
                            На карте
                        </Button>
                    </div>
                </div>
                <div>
                    {isListDisplayed && (
                        <PickupPointList
                            currentTownId={currentTownId}
                            // choosePickPoint={changeBranchMobile}
                            choosePickPoint={changeBranch}
                            pickupPoints={filterBranches(branches)}
                            // changeCheckedPickPoint={changeBranchMobile}
                            changeCheckedPickPoint={changeBranch}
                        />
                    )}
                    {!isListDisplayed && (
                        <div className={styles.map}>
                            {branches.length ?
                                (<YMaps>
                                    <Map
                                        defaultState={{
                                            zoom: 14,
                                            controls: [],
                                            center: centerMapCoordinates,
                                        }}
                                        state={{
                                            zoom: 14,
                                            controls: [],
                                            center: centerMapCoordinates,
                                        }}
                                        width="100%"
                                        height={485}
                                    >
                                        {filterBranches(branches).map(branch => {
                                            if(!branch.latitude || !branch.longitude || (branch.townId !== currentTownId && !(currentTownId !== 1 && branch.id === 1))) return null;

                                            return  <Placemark
                                                modules={["geoObject.addon.balloon"]}
                                                key={branch.id}
                                                defaultGeometry={[branch.latitude, branch.longitude]}
                                                onClick={() => changeBranch(branch)}
                                                // onClick={() => changeBranchMobile(branch)}
                                            />
                                        })}
                                    </Map>
                                </YMaps>) : null}
                        </div>
                    )}
                </div>
            </ MobileModal>
        )
};
